import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { colorPalette, fonts } from '@/styles/styleGuide';
import Caret from '../../icons/Caret';
import ErrorMessage from './ErrorMessage';
import Label from './Label';
import ReactSelect from 'react-select';
var defaultProps = {};
var Select = function Select(props) {
  var findValue = props.choices.find(function (choice) {
    return choice.key === props.defaultValue;
  });
  var options = [{
    value: '',
    label: '- Maak een keuze -',
    isDisabled: true
  }].concat(_toConsumableArray(props.choices.map(function (choice, index) {
    var _choice$disabled;
    return {
      value: choice.value,
      label: choice.key,
      isDisabled: (_choice$disabled = choice.disabled) !== null && _choice$disabled !== void 0 ? _choice$disabled : false
    };
  })));
  var onChangeHandler = function onChangeHandler(selectedOption) {
    var questionKey = props.id;
    var answeredItem = {
      questionKey: questionKey,
      target: {
        id: props.id,
        name: props.name,
        value: selectedOption ? selectedOption.value : '',
        type: props.type
      }
    };
    props.onChange(answeredItem);
  };
  return __jsx(FormSelectContainer, {
    "data-id": "fieldTypes_Select_FormSelectContainer"
  }, __jsx(Label, {
    name: props.name,
    content: props.title,
    required: props.required,
    mode: "label",
    "data-id": "fieldTypes_Select_Label"
  }), __jsx(ReactSelect, {
    name: props.name,
    options: options,
    placeholder: "- Maak een keuze -",
    isMulti: props.isMultiple,
    isClearable: !props.required,
    isDisabled: props.disabled,
    menuPlacement: "auto",
    menuPosition: "fixed",
    menuPortalTarget: document.body,
    onChange: function onChange(selectedOption) {
      props.onChange({
        target: {
          name: props.name,
          value: selectedOption ? selectedOption.value : '',
          type: 'select-one',
          validity: {
            valid: !!(selectedOption && selectedOption.value)
          }
        }
      });
    },
    theme: function theme(_theme) {
      return _objectSpread(_objectSpread({}, _theme), {}, {
        colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
          primary: '#8C8279',
          primary50: '#1FABDE'
        })
      });
    },
    styles: {
      control: function control(base, state) {
        return _objectSpread(_objectSpread({}, base), {}, {
          color: '#544E48',
          border: '0',
          borderBottom: state.isFocused ? '2rem solid #8C8279' : '1rem solid #8C8279',
          borderRadius: '0px',
          fontFamily: 'Foco, sans-serif',
          boxShadow: 'none',
          outline: 'none'
        });
      },
      option: function option(base, state) {
        return _objectSpread(_objectSpread({}, base), {}, {
          backgroundColor: state.isDisabled ? '#F5F5F5' : state.isSelected || state.isFocused || state.isActive ? '#1FABDE' : 'white',
          color: state.isDisabled ? '#B0B0B0' : state.isSelected || state.isFocused || state.isActive ? 'white' : 'black',
          cursor: state.isDisabled ? 'not-allowed' : 'pointer'
        });
      },
      menuPortal: function menuPortal(base) {
        return _objectSpread(_objectSpread({}, base), {}, {
          zIndex: 9999
        });
      }
    },
    "data-id": "fieldTypes_Select_ReactSelect"
  }), props.validationMessage && __jsx(ErrorMessage, {
    isValid: props.isValid,
    message: props.validationMessage,
    "data-id": "fieldTypes_Select_ErrorMessage"
  }));
};
Select.defaultProps = defaultProps;
export default Select;
var FormSelectContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  min-width: 250rem;\n  min-height: 46rem;\n"])));
var SelectParent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var SelectCaret = styled(Caret)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 10rem;\n  margin: auto 0;\n  top: 0;\n  bottom: 0;\n"])));
var FormSelect = styled.select(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  z-index: 1;\n  width: 100%;\n  height: 46rem;\n  border: 0;\n  border-bottom: solid 1rem ", ";\n  border-radius: initial;\n  background: transparent;\n  appearance: none;\n  position: relative;\n  font-family: ", ";\n  font-size: 100%;\n  color: ", ";\n  padding-bottom: 1rem;\n  transition: border 0.15s ease-in-out;\n\n  &:focus {\n    outline: 0;\n    border-bottom: solid 2rem ", ";\n    padding-bottom: 0;\n\n    ~ span {\n      width: 2rem;\n      background: ", ";\n    }\n  }\n"])), colorPalette.beige, fonts.primary, colorPalette.textGrey, colorPalette.beige, colorPalette.beige);
var Option = styled.option(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &:first-child {\n    color: ", ";\n    font-style: italic;\n  }\n"])), colorPalette.textGrey, colorPalette.lightBeige);